export const environment = {
  production: true,
  api: 'https://heimdall.gjbl.com.br/api-int',
  suriWebchatId: 'cb76752223',
};
